import { ALL_DOCUMENT_OPTIONS } from '@/constant';
import { memo, useCallback, useMemo, useRef } from 'react';

import './style.scss';

import { Modal } from '..';
import { IProps, WrapDocumentRef } from './define-document-write.type';
import WrapDocument from './wrap-document.view';

const DefineDocumentWrite = (props: IProps) => {
	const { open, ...rest } = props;

	const wrapRef = useRef<WrapDocumentRef>(null);

	const title = useMemo(() => {
		const option = ALL_DOCUMENT_OPTIONS.find(
			(item) => item.value === rest.documentType
		);
		const pageLabel = rest.refTableName
			? option?.labelByPage?.[rest.refTableName]
			: undefined;
		return ((pageLabel ?? option?.label) as string) || '';
	}, [rest.documentType, rest.refTableName]);

	const onCancel = useCallback(() => {
		wrapRef.current?.onCancel();
	}, []);

	return (
		<Modal
			destroyOnClose
			open={open}
			onCancel={onCancel}
			title={title}
			{...rest}
			className="!w-[798px] h-screen document-write"
		>
			<WrapDocument {...rest} title={title} ref={wrapRef} />
		</Modal>
	);
};

export default memo(DefineDocumentWrite);
